var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "53px",
    height: "46px",
    viewBox: "281 40 53 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "icon-calendar-path-1",
    points: "0 43.5939669 51.5979381 43.5939669 51.5979381 5.30036523e-05 0 5.30036523e-05"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(282.000000, 41.993348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.3670227,5.16631899 L41.0988165,5.16631899 L41.0988165,8.87657464 C41.0988165,9.60537486 40.4957237,10.201666 39.7586103,10.201666 L39.2530845,10.201666 C38.5159711,10.201666 37.9128784,9.60537486 37.9128784,8.87657464 L37.9128784,5.16631899 L31.9607546,5.16631899 L31.9607546,8.87657464 C31.9607546,9.60537486 31.3576619,10.201666 30.6205485,10.201666 L30.1155588,10.201666 C29.3784454,10.201666 28.7753526,9.60537486 28.7753526,8.87657464 L28.7753526,5.16631899 L22.8226928,5.16631899 L22.8226928,8.87657464 C22.8226928,9.60537486 22.2196,10.201666 21.4824866,10.201666 L20.9774969,10.201666 C20.2403835,10.201666 19.6372907,9.60537486 19.6372907,8.87657464 L19.6372907,5.16631899 L13.6846309,5.16631899 L13.6846309,8.87657464 C13.6846309,9.60537486 13.0815381,10.201666 12.3444247,10.201666 L11.8394351,10.201666 C11.1023216,10.201666 10.4992289,9.60537486 10.4992289,8.87657464 L10.4992289,5.16631899 L3.23102268,5.16631899 C1.60133196,5.16631899 0.268094845,6.48451982 0.268094845,8.09583085 L0.268094845,40.3994367 C0.268094845,42.0107478 1.60133196,43.3289486 3.23102268,43.3289486 L48.3670227,43.3289486 C49.9967134,43.3289486 51.3299505,42.0107478 51.3299505,40.3994367 L51.3299505,8.09583085 C51.3299505,6.48451982 49.9967134,5.16631899 48.3670227,5.16631899 L48.3670227,5.16631899 Z",
    id: "Stroke-1",
    stroke: "#D74830"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6848454,5.16631899 L13.6848454,1.59864316 C13.6848454,0.869842937 13.0817526,0.273551849 12.3446392,0.273551849 L11.8396495,0.273551849 C11.1025361,0.273551849 10.4994433,0.869842937 10.4994433,1.59864316 L10.4994433,5.16631899",
    id: "Stroke-3",
    stroke: "#D74830"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8147588,5.15805042 L22.8147588,1.59037459 C22.8147588,0.861574367 22.211666,0.265283279 21.4745526,0.265283279 L20.9695629,0.265283279 C20.2324495,0.265283279 19.6293567,0.861574367 19.6293567,1.59037459 L19.6293567,5.15805042",
    id: "Stroke-5",
    stroke: "#D74830"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9533031,5.16631899 L31.9533031,1.59864316 C31.9533031,0.869842937 31.3502103,0.273551849 30.6130969,0.273551849 L30.1081072,0.273551849 C29.3709938,0.273551849 28.767901,0.869842937 28.767901,1.59864316 L28.767901,5.16631899",
    id: "Stroke-7",
    stroke: "#D74830"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1225113,5.16631899 L41.1225113,1.59864316 C41.1225113,0.869842937 40.5194186,0.273551849 39.7823052,0.273551849 L39.2773155,0.273551849 C38.5402021,0.273551849 37.9371093,0.869842937 37.9371093,1.59864316 L37.9371093,5.16631899",
    id: "Stroke-9",
    stroke: "#D74830"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4993361,5.16631899 L10.4993361,8.87657464 C10.4993361,9.60537486 11.1024289,10.201666 11.8395423,10.201666 L12.344532,10.201666 C13.0816454,10.201666 13.6847381,9.60537486 13.6847381,8.87657464 L13.6847381,5.16631899",
    id: "Stroke-11",
    stroke: "#D74830"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.357942268,14.7069764 L51.4197979,14.7069764",
    id: "Stroke-13",
    stroke: "#D74830"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon-calendar-path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-16"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-15",
    stroke: "#D74830",
    mask: "url(#mask-2)",
    points: "6.12098969 26.6990527 12.6209897 26.6990527 12.6209897 20.2723599 6.12098969 20.2723599"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-17",
    stroke: "#D74830",
    mask: "url(#mask-2)",
    points: "16.8426392 26.6990527 23.3426392 26.6990527 23.3426392 20.2723599 16.8426392 20.2723599"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-18",
    stroke: "#D74830",
    mask: "url(#mask-2)",
    points: "27.5642887 26.6990527 34.0642887 26.6990527 34.0642887 20.2723599 27.5642887 20.2723599"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-19",
    stroke: "#D74830",
    mask: "url(#mask-2)",
    points: "38.2859381 26.6990527 44.7859381 26.6990527 44.7859381 20.2723599 38.2859381 20.2723599"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-20",
    stroke: "#D74830",
    mask: "url(#mask-2)",
    points: "6.12098969 37.2997832 12.6209897 37.2997832 12.6209897 30.8730903 6.12098969 30.8730903"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-21",
    stroke: "#D74830",
    mask: "url(#mask-2)",
    points: "16.8426392 37.2997832 23.3426392 37.2997832 23.3426392 30.8730903 16.8426392 30.8730903"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-22",
    stroke: "#D74830",
    mask: "url(#mask-2)",
    points: "27.5642887 37.2997832 34.0642887 37.2997832 34.0642887 30.8730903 27.5642887 30.8730903"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-23",
    stroke: "#D74830",
    mask: "url(#mask-2)",
    points: "38.2859381 37.2997832 44.7859381 37.2997832 44.7859381 30.8730903 38.2859381 30.8730903"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a4864524de5ac67d28ee6edce17122c9.svg";
export { ForwardRef as ReactComponent };